/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import WriteReview from './write-review';
import WriteReviewView from './write-review.view';

export * from './write-review';
export * from './write-review.data';
export { IWriteReviewConfig, IWriteReviewProps, IWriteReviewResources } from './write-review.props.autogenerated';
export * from './write-review.view';

export {
    WriteReview,
    WriteReviewView
};
